'use client';

import classNames from 'classnames';

import { RecapAsset } from '@/api/trading/types';
import { AssetIcon } from '@/blocks/components/AssetIcon';
import { useSignup } from '@/blocks/components/PlatformLink';
import { WithTrendColor } from '@/blocks/components/WithTrendColor';
import { FormatAssetName, FormatPercent, FormatPrice } from '@/blocks/formatters';
import { extractAssetName } from '@/blocks/formatters/format-asset-name';
import typography from '@/styles/typography.module.scss';

import styles from './styles.module.scss';

function RankingCardTableHeader({ fields }: { fields: any[] }) {
  return (
    <thead className={classNames(typography.bodyS)}>
      <tr>
        {fields.map((field) => (
          <th key={field.header}>
            <div>{field.header}</div>
          </th>
        ))}
      </tr>
    </thead>
  );
}

function CellChange({ asset }: { asset: RecapAsset }) {
  return (
    <WithTrendColor valueToCalculateTrend={asset.change24h}>
      <FormatPercent value={asset.change24h} forcePlusSign={false} />
    </WithTrendColor>
  );
}

function CellName({ asset }: { asset: RecapAsset }) {
  return (
    <div className={styles.assetCell}>
      <AssetIcon loading={'eager'} assetName={asset.name} />
      <span>
        <FormatAssetName assetName={extractAssetName(asset)} />
      </span>
    </div>
  );
}

function CellPrice({ asset }: { asset: RecapAsset }) {
  return (
    <div className={styles.priceCell}>
      <span>
        <FormatPrice price={asset.price} priceScale={asset.priceScale} />
      </span>
    </div>
  );
}

const f = {
  name: CellName,
  price: CellPrice,
  change24h: CellChange,
};

function RankingCardTableBody(props: { assets: RecapAsset[]; fields: any[] }) {
  const { openSignupWithAsset } = useSignup();

  return (
    <tbody className={classNames(typography.bodyM)}>
      {props.assets.map((asset, index) => (
        <tr key={asset.name} onClick={(e) => openSignupWithAsset({ asset, newTab: e.metaKey })} role={'link'}>
          {props.fields.map((field) => {
            const CellToRender = f[field.field as keyof typeof f];
            return (
              <td key={field.field}>
                <CellToRender asset={asset} />
              </td>
            );
          })}
        </tr>
      ))}
    </tbody>
  );
}

export function RankingCardTable(props: { assets: RecapAsset[]; fields: any[] }) {
  return (
    <div>
      <table className={styles.table}>
        <RankingCardTableHeader fields={props.fields} />
        <RankingCardTableBody assets={props.assets} fields={props.fields} />
      </table>
    </div>
  );
}
